import React, { PropsWithChildren, useState } from 'react'
import { Button, ButtonProps, Flex, Modal, Text } from '@workwhile/ui'

export const ButtonWithConfirmation = ({
  message,
  children,
  onClick,
  ...buttonProps
}: PropsWithChildren<ButtonProps & { message: string }>) => {
  const [isOpen, setIsOpen] = useState(false)

  const handleClick = () => {
    setIsOpen(true)
  }

  const handleConfirm = () => {
    onClick()
    setIsOpen(false)
  }

  return (
    <>
      <Button {...buttonProps} onClick={handleClick}>
        {children}
      </Button>
      {isOpen ? (
        <Modal open={isOpen} onClose={() => setIsOpen(false)}>
          <Text>{message}</Text>
          <Flex mt={4} gap={2}>
            <Button onClick={handleConfirm}>Confirm</Button>
            <Button onClick={() => setIsOpen(false)}>Cancel</Button>
          </Flex>
        </Modal>
      ) : null}
    </>
  )
}
